// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceRecordFormat
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DataSourceField } from "abweb/dto/ds/DataSourceField";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class DataSourceRecordFormatBase {
  /** Do NOT invoke directly, instead use strongly typed createDataSourceRecordFormatBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.DataSourceRecordFormat";
  }
  initFromJson(json, deserializeContext) {
    this.initDataSourceRecordFormat(json.editable != null ? json.editable : null, json.fields != null ? TSOGUtils.decodeObjectMap(json.fields, DataSourceField, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "fields")) : null, json.name != null ? json.name : null);
  }
  initDataSourceRecordFormat(editable, fields, name) {
    this._editable = editable;
    this._fields = fields;
    this._name = name;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["editable"] = this._editable;
    retVal["fields"] = TSOGUtils.toTSOGMap(this._fields, serializeContext);
    retVal["name"] = this._name;
    return retVal;
  }
  get editable() {
    return this._editable;
  }
  set editable(value) {
    this._editable = value;
  }
  get fields() {
    return this._fields;
  }
  set fields(value) {
    this._fields = value;
  }
  get name() {
    return this._name;
  }
  set name(value) {
    this._name = value;
  }
}
//# sourceMappingURL=DataSourceRecordFormatBase.js.map
